import { h } from 'preact'
import { ContentType, isIdea } from '../../utils/contentType'

const UnreadByTeam = () =>
  ({ contentType, moderationStatus: { repliedSinceLastModeration, isModerated } } : { contentType: ContentType, moderationStatus: { repliedSinceLastModeration: number, isModerated: boolean }}) =>
    isIdea(contentType) ? <div class='overview__unread-by-team--not-supported'>(Not supported)</div>
      : <div class='overview__unread-by-team'>
        { !isModerated && <div>New topic{repliedSinceLastModeration > 0 && (' (+' + repliedSinceLastModeration + ')')}</div>}
        { isModerated && repliedSinceLastModeration > 0 && <div>+ { repliedSinceLastModeration } Replies</div> }
      </div>

export default UnreadByTeam
